import bird from './Birds.mp3';
import forest from './recordings/forest.mp3';
import waterStream from './recordings/stream.mp3';
import bonFire from './BonFire.mp3';
import night from './recordings/night.mp3';
import submarine from './Bubble.mp3';
import bubble from './HeavyBubbles.mp3'
import rain from './RainOnRoof.mp3';
import thunder from './recordings/thunder.mp3';
import waves from './recordings/waves.mp3';
import wind from './recordings/wind.mp3';
import publicPlace from './PublicPlace.mp3';
import plane from './InThePlane.mp3';
import train from './Train.mp3';
import seaShore from './recordings/shore.mp3';
import seagle from './Seagle.mp3';
import frog from './recordings/frog.mp3';
import windOverGrass from './recordings/grass.mp3';

export const BirdSound = bird;
export const ForestSound = forest;
export const WaterStreamSound = waterStream;
export const BonFireSound = bonFire;
export const NightSound = night;
export const SubmarineSound = submarine;
export const BubbleSound = bubble;
export const RainSound = rain;
export const ThunderSound = thunder;
export const WavesSound = waves;
export const WindSound = wind;
export const PublicPlaceSound = publicPlace;
export const PlaneSound = plane;
export const SeaShoreSound = seaShore;
export const TrainSound = train;
export const SeagleSound = seagle;
export const FrogSound = frog;
export const WindOnGrassSound = windOverGrass;
